"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPopUp = exports.closePopUp = void 0;
var popUp_html_1 = __importDefault(require("./popUp.html"));
var sessionStorageKey = 'widgetPopUpClosed';
var defaultIntervalSeconds = 5;
var checkPopUpRules = function (_a) {
    var text = _a.text, interval = _a.interval, isActive = _a.isActive;
    if (window.sessionStorage.getItem(sessionStorageKey) === 'true' ||
        isActive === false ||
        !text ||
        (typeof interval !== 'number' && interval !== null) ||
        (typeof interval === 'number' && interval < 0))
        return false;
    return true;
};
var setupWrapper = function (position, openWidget) {
    var popUpWrapper = document.getElementById('widgetPopUpWrapper');
    popUpWrapper === null || popUpWrapper === void 0 ? void 0 : popUpWrapper.classList.add('widget-popup-wrapper-hidden');
    popUpWrapper === null || popUpWrapper === void 0 ? void 0 : popUpWrapper.classList.add("widget-popup-wrapper-".concat(position));
    popUpWrapper === null || popUpWrapper === void 0 ? void 0 : popUpWrapper.addEventListener('click', function () {
        (0, exports.closePopUp)();
        openWidget();
    });
};
var setupCloseButton = function () {
    var closeButton = document.getElementById('closePopUpButton');
    closeButton === null || closeButton === void 0 ? void 0 : closeButton.addEventListener('click', function (e) {
        e.stopPropagation();
        (0, exports.closePopUp)();
    });
};
var setupText = function (title, text) {
    var _a, _b;
    var titleSpan = document.querySelector('.widget-popup-title span');
    var textSpan = document.querySelector('.widget-popup-text span');
    var closeButton = document.getElementById('closePopUpButton');
    if (!textSpan || !closeButton)
        return;
    textSpan.textContent = text;
    if (title && titleSpan) {
        titleSpan.textContent = title;
        (_a = titleSpan.parentNode) === null || _a === void 0 ? void 0 : _a.insertBefore(closeButton, titleSpan.nextSibling);
    }
    else
        (_b = textSpan.parentNode) === null || _b === void 0 ? void 0 : _b.insertBefore(closeButton, textSpan.nextSibling);
};
var openPopUp = function (popUpSettings) {
    if (!checkPopUpRules(popUpSettings))
        return;
    var popUpWrapper = document.getElementById('widgetPopUpWrapper');
    popUpWrapper === null || popUpWrapper === void 0 ? void 0 : popUpWrapper.classList.remove('widget-popup-wrapper-hidden');
    popUpWrapper === null || popUpWrapper === void 0 ? void 0 : popUpWrapper.classList.add('widget-popup-wrapper-shown');
};
var closePopUp = function () {
    var popUpWrapper = document.getElementById('widgetPopUpWrapper');
    popUpWrapper === null || popUpWrapper === void 0 ? void 0 : popUpWrapper.classList.remove('widget-popup-wrapper-shown');
    popUpWrapper === null || popUpWrapper === void 0 ? void 0 : popUpWrapper.classList.add('widget-popup-wrapper-hidden');
    window.sessionStorage.setItem(sessionStorageKey, 'true');
};
exports.closePopUp = closePopUp;
var setPopUp = function (popUpSettings, _a) {
    var appendCallback = _a.appendCallback, openWidget = _a.openWidget;
    var title = popUpSettings.title, text = popUpSettings.text, interval = popUpSettings.interval, position = popUpSettings.position;
    if (!checkPopUpRules(popUpSettings))
        return;
    appendCallback(popUp_html_1.default);
    setupWrapper(position, openWidget);
    setupCloseButton();
    setupText(title, text);
    setTimeout(function () { return openPopUp(popUpSettings); }, (interval || defaultIntervalSeconds) * 1000);
};
exports.setPopUp = setPopUp;
